<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getCourseView } from "@/api/course-details.js";
export default {
  name: "App",
  watch: {
    $route(to, from) {
      if (to.query.constructionId) {
        let params = { constructionId: to.query.constructionId };
        this.getCourseView(params);
      } else {
        document.getElementsByTagName("title")[0].innerText = `职教在线平台`;
      }

      if (to.path.indexOf("courseLearning") != -1) {
        let params = { constructionId: this.$store.state.constructionId };
        this.getCourseView(params);
      } else {
        document.getElementsByTagName("title")[0].innerText = `职教在线平台`;
      }
    },
  },
  created() {
    this.getRem(1920, 100);
    window.onresize = () => {
      this.getRem(1920, 100);
    };
  },
  methods: {
    // 设置根大小，元素宽高字体大小都可以用rem,10px = 0.1rem
    getRem(pwidth, prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },
    getCourseView(params) {
      getCourseView(params).then((res) => {
        if (res.data.code == 200) {
          document.getElementsByTagName(
            "title"
          )[0].innerText = `职教在线平台-${res.data.result.courseName}`;
          this.$store.commit("courseInfo", res.data.result);
        }
      });
    },
  },
};
</script>

<style>
#app {
  position: relative;
  min-height: 100vh;
}
/* 全局样式或组件内scoped样式 */
.isDrag .prism-progress {
  pointer-events: none !important;
}
.isDrag::-webkit-media-controls-timeline {
  display: none !important;
}
.isDrag::-webkit-media-controls-progress-bar {
  pointer-events: none !important;
}
</style>
